import React from 'react';
import { Layout } from '../components/layout/Layout';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Scale, FileText, MessageSquare, CheckCircle } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

export default function DisputesPage() {
  return (
    <Layout>
      <div className="container-app py-12 max-w-4xl">
        <div className="text-center mb-12">
          <Scale className="w-16 h-16 mx-auto mb-4 text-primary" />
          <h1 className="text-4xl font-bold mb-4">Résolution de Litiges</h1>
          <p className="text-lg text-muted-foreground">
            Comment gérer les désaccords sur Oknî
          </p>
        </div>

        <div className="space-y-8">
          <Card className="rounded-2xl">
            <CardHeader>
              <CardTitle>Notre Rôle</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p>
                Oknî est une <strong>plateforme de mise en relation</strong> entre membres de la communauté. 
                Nous ne sommes pas partie prenante des échanges et n'agissons pas comme juge ou arbitre.
              </p>
              <p className="text-muted-foreground">
                Notre mission est de fournir un canal de résolution amiable et de prendre des mesures 
                pour préserver la sécurité et la qualité de la plateforme.
              </p>
            </CardContent>
          </Card>

          <Card className="rounded-2xl">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <FileText />
                Procédure de Signalement
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-bold">1</div>
                  <div>
                    <h3 className="font-semibold">Signaler le problème</h3>
                    <p className="text-muted-foreground">Utilisez le bouton "Signaler" sur le service, l'utilisateur ou la réservation concernée.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-bold">2</div>
                  <div>
                    <h3 className="font-semibold">Analyse par l'équipe</h3>
                    <p className="text-muted-foreground">Notre équipe étudie chaque signalement et les éléments fournis.</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <div className="flex-shrink-0 w-8 h-8 bg-primary text-white rounded-full flex items-center justify-center font-bold">3</div>
                  <div>
                    <h3 className="font-semibold">Décision et actions</h3>
                    <p className="text-muted-foreground">Selon la gravité : avertissement, suspension, désactivation de contenu ou exclusion.</p>
                  </div>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="rounded-2xl">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <MessageSquare />
                Résolution Amiable
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <p>
                Avant de signaler, nous vous encourageons à <strong>communiquer directement</strong> 
                avec l'autre membre via la messagerie pour tenter de résoudre le malentendu.
              </p>
              <p className="text-muted-foreground">
                La plupart des désaccords peuvent être résolus par le dialogue.
              </p>
            </CardContent>
          </Card>

          <Card className="rounded-2xl">
            <CardHeader>
              <CardTitle className="flex items-center gap-2">
                <CheckCircle />
                Sanctions Possibles
              </CardTitle>
            </CardHeader>
            <CardContent>
              <ul className="space-y-2 list-disc list-inside">
                <li>Avertissement écrit</li>
                <li>Retrait du contenu signalé</li>
                <li>Suspension temporaire du compte</li>
                <li>Exclusion définitive de la plateforme</li>
              </ul>
              <p className="text-muted-foreground mt-4">
                Les sanctions dépendent de la gravité et de la récurrence des infractions.
              </p>
            </CardContent>
          </Card>

          <div className="text-center">
            <Link to="/contact">
              <Button className="btn-primary">
                Contacter le Support
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
}
